import React from 'react';
import axios from 'axios';
import { useSelector, useDispatch } from 'react-redux';
import { ButtonToolbar, Button } from 'react-bootstrap';
import { history } from 'store/configureStore';
import SortTable from 'components/parts/item/sortTable';
import Account from 'components/adm/account/account';
import GlobalLoading from 'components/parts/loading/buttonLoading';
import StatusInfoPopup from 'components/adm/account/statusInfoPopup';
import { getAccounts } from 'actions/accountAction';
import { setMessage, clearMessage } from 'actions/messageAction';
import { setLoading, clearLoading } from 'actions/loadingAction';
import { lang } from 'lang';
import { createUniqueStr, consoleLogger } from 'helpers';

/**
 * 管理者アカウントをテーブルで表示するコンポーネント
 */
const AccountList = () => {
  const { msg, error } = lang;
  const [ buttonStatus, setButtonStatus ] = React.useState(false);
  const dispatch = useDispatch();
  // グローバルステートから管理者アカウント情報を取得する
  const admAccountState = useSelector((state) => state.account);
  // リクエストキャンセルトークンを取得
  const cancelToken = axios.CancelToken.source();

  React.useEffect(() => {
    const values = {
      search_attr: admAccountState.search_attr,
      search_str: admAccountState.search_str,
      pagination: null,
    };
    getData(values, cancelToken, false);
    return () => {
      // unmounted component時にコールされる
      cancelToken.cancel('unmounted component.');
    };
  },[]);

  // さらにロードボタンをクリックしたときに実行する処理
  const loadMore = () => {
    const values = {
      search_attr: admAccountState.search_attr,
      search_str: admAccountState.search_str,
      pagination: admAccountState.pagination,
    };
    getData(values, cancelToken, true, 'button');
  };

  // 管理者アカウントを一覧取得する 
  const getData = async (values, cancelToken, isLoadMore, loading = 'unit') => {
    try {
      if (loading === 'button') {
        dispatch(setLoading('button', 'refreshAccount'));
      } else {
        dispatch(setLoading('unit'));
      }

      // メッセージを初期化
      dispatch(clearMessage());

      // さらにロードボタンを非活性化
      setButtonStatus(true);
      await dispatch(
        await getAccounts(values, cancelToken, isLoadMore)
      ).then((result) => {
        if (result.status === 200) {
          // 他の画面から渡されたメッセージをセットする(登録・削除・編集)
          if (history.location.state && history.location.state.message && history.location.state.message.type && history.location.state.message.msg) {
            const { type, msg } = history.location.state.message;
            // メッセージをセット
            dispatch(setMessage(type, msg));
            // ヒストリーの初期化
            history.replace({pathname: '/adm/accounts', state: {}});
          } else if (result.count === 0) {
            dispatch(setMessage('info', msg.account.not_found));
          }
        } else {
          dispatch(setMessage('danger', error.account.gets + `\n${result.errcode}`));
        }
      });
      // さらにロードボタンを活性化
      setButtonStatus(false);
      dispatch(clearLoading());
    } catch (e) {
      consoleLogger('Fail get account list.', e);
    }
  };

  // テーブルヘッダー定義
  const headers = { items: [], operations: {total: 1} };
  headers.items = [
    { attribute: {}, sort: {}, name: 'Name'},
    { attribute: {}, sort: {}, name: 'E-mail'},
    { attribute: {}, sort: {}, name: 'Phone'},
    { attribute: {}, sort: {}, name: 'Status'},
    { attribute: {}, sort: {}, name: <>Verification<StatusInfoPopup /></>},
  ];
  return (
    <>
      {<SortTable headers={headers} state={{status: createUniqueStr(), items: admAccountState.items}} component={Account}/>}
      {admAccountState.pagination && <ButtonToolbar className="justify-content-center">
        {!buttonStatus && admAccountState.pagination && <Button disabled={buttonStatus}  onClick={() => loadMore()}>
        More...
        </Button>}
        {buttonStatus && <GlobalLoading buttonName="refreshAccount" />}
      </ButtonToolbar>}
    </>
  );
};

export default AccountList;
